import { styled } from '@mui/material'
import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'
import { getWbsItemStatusLabel } from '../../../lib/functions/wbsItem'
import { colorPalette } from '../../style/colorPalette'

const STATUS_CHIP_SHADOW_ALPHA_HEX = '4D'

// TODO
// Possibility to keep color in DB in the future
export const getOptionStyles = (value: string) => {
  switch (value) {
    case WbsItemStatus.TODO:
      return {
        backgroundColor: `${colorPalette.monotone[1]}`,
        textColor: `${colorPalette.monotone[4]}`,
        borderColor: `1px solid ${colorPalette.monotone[2]}`,
      }
    case WbsItemStatus.DOING:
      return {
        backgroundColor: `${colorPalette.yellow[1]}`,
        textColor: `${colorPalette.yellow[4]}`,
        borderColor: `1px solid ${colorPalette.yellow[2]}`,
      }
    case WbsItemStatus.REVIEW:
      return {
        backgroundColor: `${colorPalette.green[1]}`,
        textColor: `${colorPalette.green[7]}`,
        borderColor: `1px solid ${colorPalette.green[2]}`,
      }
    case WbsItemStatus.DONE:
      return {
        backgroundColor: `${colorPalette.skyBlue[1]}`,
        textColor: `${colorPalette.skyBlue[7]}`,
        borderColor: `1px solid ${colorPalette.skyBlue[2]}`,
      }
    case WbsItemStatus.DISCARD:
      return {
        backgroundColor: `${colorPalette.monotone[3]}`,
        textColor: `${colorPalette.monotone[0]}`,
        borderColor: `1px solid ${colorPalette.monotone[3]}`,
      }
    default:
      return {
        backgroundColor: `${colorPalette.monotone[0]}`,
        textColor: `${colorPalette.monotone[10]}`,
        borderColor: `${colorPalette.monotone[10]}`,
      }
  }
}

type WbsItemStatusChipProps = {
  status: WbsItemStatus
}

export const WbsItemStatusChip = ({ status }: WbsItemStatusChipProps) => {
  const { backgroundColor, textColor, borderColor } = getOptionStyles(status)
  return (
    <Chip
      bgColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
    >
      {getWbsItemStatusLabel(status)}
    </Chip>
  )
}

type ChipProps = {
  bgColor: string
  textColor: string
  borderColor: string
}

const Chip = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'bgColor' && prop !== 'textColor' && prop !== 'borderColor',
})<ChipProps>(({ bgColor, textColor, borderColor }) => ({
  maxWidth: '100%',
  height: '22px',
  lineHeight: '22px',
  padding: '0 8px',
  boxSizing: 'border-box',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 500,
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  backgroundColor: bgColor,
  color: textColor,
  border: borderColor,
  boxShadow: `0px 1px 2px 0px ${colorPalette.monotone[4]}${STATUS_CHIP_SHADOW_ALPHA_HEX}`,
}))
